<template>
    <div>
        <div v-if="showopenmodal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-md" style="display: block !important">
                            <div class="modal-content cps-content">
                                <!-- Header -->
                                <div class="cps-header">
                                    <div class="cps-header-icon">
                                        <i class="material-icons">share</i>
                                    </div>
                                    <div class="cps-header-text">
                                        <h5 class="cps-title">Consolidated Print Sections</h5>
                                        <p class="cps-subtitle">
                                            Choose which sections appear on the consolidated print
                                        </p>
                                    </div>
                                    <button type="button" class="cps-close" @click="cancelAction()">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>

                                <!-- Body -->
                                <div class="cps-body">
                                    <div v-if="showspinner" class="appointmentlist-spinner">
                                        <div class="processing_popup full-spinner"
                                            style="visibility: visible; top: 0; height: 100%; z-index: 9999999999;">
                                            <div class="spinner cover-spin">
                                                <div class="bounce1"></div>
                                                <div class="bounce2"></div>
                                                <div class="bounce3"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cps-section-label">PRINT SECTIONS</div>

                                    <label v-for="section in sections" :key="section.value" class="cps-card"
                                        :for="'cps-' + section.value">
                                        <span class="cps-icon"
                                            :style="{ background: meta(section.value).bg, color: meta(section.value).fg }">
                                            <i class="material-icons">{{ meta(section.value).icon }}</i>
                                        </span>
                                        <span class="cps-card-text">
                                            <span class="cps-card-title">{{ section.label }}</span>
                                            <span class="cps-card-desc">{{ meta(section.value).desc }}</span>
                                        </span>
                                        <span class="cps-switch">
                                            <input type="checkbox" :id="'cps-' + section.value" :value="section.value"
                                                v-model="selectedSections" />
                                            <span class="cps-slider"></span>
                                        </span>
                                    </label>

                                    <div v-if="!sections.length && !showspinner" class="cps-empty">
                                        No sections available
                                    </div>
                                </div>

                                <!-- Footer -->
                                <div class="cps-footer">
                                    <div class="cps-note">
                                        <i class="material-icons">info</i>
                                        <span v-if="selectedSections.length">
                                            Changes apply immediately for all users on reload
                                        </span>
                                        <span v-else class="cps-note-warn">Select at least one section</span>
                                    </div>
                                    <button type="button" class="cps-save" :disabled="!selectedSections.length || showspinner"
                                        @click="saveSettings()">
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <Messages v-if="isdisplaymsg" v-bind:datamessage="sucessmsgtext" v-bind:iserror="iserrormsg"
            v-on:closemsg="closeMessage" v-bind:isVisible="isdisplaymsg"></Messages>
    </div>
</template>

<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import SubscriptionApi from "../../api/subscription.js";

// UI-only metadata keyed by enum value returned from the API
const SECTION_META = {
    Vitals: { icon: "favorite", desc: "Show vitals on consolidated print", bg: "#fde8ea", fg: "#e53950" },
    SymptomsAndSummary: { icon: "notes", desc: "Show symptoms and summary on consolidated print", bg: "#e1f3fd", fg: "#1e88e5" },
    Prescription: { icon: "local_pharmacy", desc: "Show prescription on consolidated print", bg: "#fdf0dc", fg: "#f08c00" },
    Investigations: { icon: "science", desc: "Show ordered investigations on consolidated print", bg: "#e8f5e9", fg: "#2e9e5b" },
    ICD10: { icon: "assignment", desc: "Show ICD10 diagnosis codes on consolidated print", bg: "#ede7f6", fg: "#6c4bc4" },
    Immunization: { icon: "healing", desc: "Show immunization details on consolidated print", bg: "#e0f7f4", fg: "#00a08a" },
    ChiefComplaints: { icon: "report_problem", desc: "Show chief complaints on consolidated print", bg: "#fff3e0", fg: "#ef6c00" },
};
const DEFAULT_META = { icon: "article", desc: "Show this section on consolidated print", bg: "#eef1f6", fg: "#5b6b82" };

export default {
    props: ["showmodal", "parentprop"],
    components: { Messages },
    data() {
        return {
            isdisplaymsg: false,
            sucessmsgtext: "",
            iserrormsg: false,
            showopenmodal: false,
            loggedInUser: null,
            showspinner: false,
            sections: [],
            selectedSections: [],
        };
    },
    watch: {
        // replaces the side-effect computed; runs on first render too
        showmodal: {
            immediate: true,
            handler(val) {
                this.showopenmodal = !!val;
                if (val) this.init();
            },
        },
    },
    methods: {
        meta(value) {
            return SECTION_META[value] || DEFAULT_META;
        },
        cancelAction() {
            this.showopenmodal = false;
            this.parentprop.opencloseConsolidatedPrintSettingsModal = false;
        },
        authHeaders(routeEntity) {
            return {
                x_tenant_id: localStorage.tenantid,
                role_unique_id: this.loggedInUser.role.unique_id,
                route_entity_name: routeEntity,
                loggedin_user_unique_id: this.loggedInUser.unique_id,
                Authorization: localStorage.accesstoken,
            };
        },
        showMessage(text, isError) {
            this.isdisplaymsg = true;
            this.iserrormsg = isError;
            this.sucessmsgtext = text;
            setTimeout(() => this.closeMessage(), 3000);
        },
        closeMessage() {
            this.isdisplaymsg = false;
        },
        // Always load the section list first, then the saved selection
        init() {
            this.loggedInUser = JSON.parse(localStorage.loggedInUserInfo);
            this.showspinner = true;

            this.fetchSections()
                .then(() => {
                    const cached = JSON.parse(localStorage.getItem("tenantbusinesssetup"));
                    if (cached) {
                        this.applySetup(cached);
                        return;
                    }
                    return SubscriptionApi.getbusinesssetup().then((response) => {
                        if (response.data && response.data.result) {
                            //localStorage.setItem("tenantbusinesssetup", JSON.stringify(response.data.result));
                            this.applySetup(response.data.result);
                        }
                    });
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.showspinner = false;
                });
        },
        fetchSections() {
            return Axios.request({
                method: "get",
                url: rest_service.baseURL + "/staff/get-consolidated-print-sections",
                headers: this.authHeaders("/get-consolidated-print-sections"),
            })
                .then((respo) => {
                    if (respo.data && respo.status) this.sections = respo.data;
                })
                .catch(() => {
                    this.showMessage("Unable to get consolidated print settings", true);
                });
        },
        applySetup(setup) {
            const saved = setup.consolidatedPrntSections;
            // nothing saved yet => everything prints, so show everything as ON
            this.selectedSections =
                saved && saved.length ? [...saved] : this.sections.map((s) => s.value);
        },
        saveSettings() {
            if (!this.selectedSections.length) return;
            this.showspinner = true;

            Axios.request({
                method: "put",
                url: rest_service.baseURL + "/staff/updateconsolidatedprintsettings",
                headers: this.authHeaders("/updateconsolidatedprintsettings"),
                withCredentials: false,
                data: { sections: this.selectedSections },
            })
                .then((respo) => {
                    this.showspinner = false;
                    this.parentprop.opencloseConsolidatedPrintSettingsModal = false;
                    if (respo.data && respo.data.result && respo.status) {
                        localStorage.setItem("tenantbusinesssetup", JSON.stringify(respo.data.result));
                        this.showMessage(
                            "Consolidated Print Settings " + this.$store.state.helper.alertmessage.saved,
                            false
                        );
                    } else {
                        this.showMessage(respo.data.result, true);
                    }
                })
                .catch(() => {
                    this.showspinner = false;
                    this.parentprop.opencloseConsolidatedPrintSettingsModal = false;
                    this.showMessage(
                        "Consolidated Print Settings " + this.$store.state.helper.alertmessage.failupdate,
                        true
                    );
                });
        },
    },
};
</script>

<style scoped>
.cps-content { border: 0; border-radius: 16px; overflow: hidden; position: relative; }

.cps-header { display: flex; align-items: flex-start; gap: 16px; padding: 24px 24px 18px; background: #fff; }
.cps-header-icon { width: 36px; display: flex; justify-content: center; padding-top: 6px; color: #111; }
.cps-header-text { flex: 1; }
.cps-title { margin: 0; font-size: 18px; font-weight: 600; color: #111827; }
.cps-subtitle { margin: 4px 0 0; font-size: 13px; color: #4b5563; line-height: 1.35; }
.cps-close { background: none; border: 0; color: #6b7280; cursor: pointer; padding: 0; }

.cps-body { background: #f6f8fc; padding: 18px 24px 8px; position: relative; max-height: 55vh; overflow-y: auto; }
.cps-section-label { font-size: 11px; font-weight: 600; letter-spacing: .08em; color: #8794a8; margin-bottom: 12px; }

.cps-card { display: flex; align-items: center; gap: 14px; background: #fff; border: 1px solid #e5eaf2;
    border-radius: 12px; padding: 12px 14px; margin-bottom: 12px; cursor: pointer; width: 100%; }
.cps-icon { width: 40px; height: 40px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.cps-icon .material-icons { font-size: 20px; }
.cps-card-text { flex: 1; display: flex; flex-direction: column; }
.cps-card-title { font-size: 14px; font-weight: 600; color: #1f2937; }
.cps-card-desc { font-size: 12px; color: #7b8798; margin-top: 2px; }

/* toggle */
.cps-switch { position: relative; width: 40px; height: 24px; flex-shrink: 0; }
.cps-switch input { opacity: 0; width: 100%; height: 100%; margin: 0; position: absolute; cursor: pointer; z-index: 1; }
.cps-slider { position: absolute; inset: 0; background: #cbd2dc; border-radius: 24px; transition: background .2s; }
.cps-slider::before { content: ""; position: absolute; height: 18px; width: 18px; left: 3px; top: 3px;
    background: #fff; border-radius: 50%; transition: transform .2s; box-shadow: 0 1px 2px rgba(0, 0, 0, .25); }
.cps-switch input:checked + .cps-slider { background: #1565c0; }
.cps-switch input:checked + .cps-slider::before { transform: translateX(16px); }

.cps-empty { text-align: center; color: #8794a8; font-size: 13px; padding: 16px 0; }

.cps-footer { display: flex; align-items: center; justify-content: space-between; gap: 16px;
    padding: 16px 24px; background: #fff; border-top: 1px solid #e5eaf2; }
.cps-note { display: flex; align-items: flex-start; gap: 8px; font-size: 11.5px; color: #7b8798; max-width: 55%; }
.cps-note .material-icons { font-size: 15px; color: #94a3b8; }
.cps-note-warn { color: #d93025; }
.cps-save { background: #0d47d9; color: #fff; border: 0; border-radius: 8px; padding: 12px 26px;
    font-size: 14px; font-weight: 600; cursor: pointer; }
.cps-save:disabled { opacity: .5; cursor: not-allowed; }
</style>